import { useContractRead } from 'wagmi';

import { peacefallABI } from '~/abis/peacefall';
import { PEACEFALL_ADDRESS, POTION_ADDRESS } from '~/constants';
import { useGetAccount } from '~/hooks/web3/useGetAccount';


export function useGetIsApproved({ enabled }: { enabled: boolean }) {
  const { data: connectedAccount } = useGetAccount();
  const signerAddress = connectedAccount?.address;
  return useContractRead({
    address: PEACEFALL_ADDRESS,
    abi: peacefallABI,
    functionName: 'isApprovedForAll',
    args: [signerAddress!, POTION_ADDRESS], // todo cleanup
    enabled: Boolean(signerAddress) && Boolean(enabled),
  });
}
